export default [
    {
        name: "Dedicated",
        slug: "dedicated",
        products: [
            {
                name: "Dedicated Server",
                plural: "Dedicated Servers",
                slug: "dedicated-server",
                add: {
                    href: "/order/dedicated-server",
                    detail: "Dedicated Servers offer exclusive hardware resources for optimal performance and control.",
                }
            },
            {
                name: "Private Cloud",
                plural: "Private Cloud",
                slug: "private-cloud",
                add: {
                    external: true,
                    href: "https://www.serversaustralia.com.au/products-services/cloud-computing/private-cloud",
                    detail: "High performance VMware based Private Cloud combines dedicated compute resources with a virtualised, highly-available environment.",
                    label: "Contact Sales"
                },
                edit: {
                    to: {
                        name: "private-cloud-summary"
                    }
                }
            }
        ]
    },
    {
        name: "Virtual",
        slug: "virtual",
        products: [
            {
                name: "Virtual Data Centre",
                plural: "Virtual Data Centres",
                slug: "virtual-data-centre",
                add: {
                    external: true,
                    href: "https://www.serversaustralia.com.au/products-services/cloud-computing/virtual-data-centres",
                    detail: "A powerful and scalable VMware-based solution giving you complete control over virtualised infrastructure.",
                },
                edit: {
                    to: {
                        name: "virtual-data-centre-summary"
                    }
                }
            },
            {
                name: "Virtual Cloud Server",
                plural: "Virtual Cloud Servers",
                slug: "vcs",
                isNonCancellable: false,
                edit: { 
                    to: {
                        name: "vcs-summary"
                    }
                 },
            },
            {
                name: "Cloud Server",
                plural: "Cloud Servers",
                slug: "vds",
                add: {
                    href: "/order/vps",
                    detail: "Get up and running quickly with our instant provisioning cloud servers, enabling you to deploy computing resources in minutes.",
                }
            },
            {
                name: "Cloud Server - Custom",
                plural: "Cloud Servers - Custom",
                slug: "cloud",
                legacy: true,
            },
            {
                name: "XenServer",
                slug: "vps-xs",
                legacy: true,
            },
        ]
    },
    {
        name: "Colocation",
        slug: "colocation",
        products: [
            {
                name: "Colocation",
                slug: "colocation",
                add: {
                    href: "/order/colocation",
                    detail: "Safeguard your infrastructure with our secure colocation services in top-tier Australian data centres.",
                }
            }
        ]
    },
    {
        name: "Storage",
        slug: "storage",
        products: [
            {
                name: "S3 Object Storage",
                slug: "object-storage",
                single: true,
                add: {
                    heading: "Object Storage not activated",
                    detail: "Object Storage is performant, scalable, S3 API compatible storage.",
                    component: "ObjectStorageSetup",
                    faq: "ObjectStorageFaq"
                },
                edit: {
                    to: {
                        name: "object-storage-overview",
                    }
                }
            },
            {
                name: "CephFS File Storage",
                slug: "cephfs-storage",
                add: {
                    detail: "The Ceph File System (CephFS) is a distributed object store and file system <br> designed to provide excellent performance, reliability, and scalability.",
                    component: "CephFsSetup",
                },
                edit: {
                    to: {
                        name: "cephfs-storage-overview"
                    }
                },
                headers: [
                    { text: 'Details', align: 'left', value: 'order_id', key: 'order_id', sortable: true, width: '25%'},
                    { text: 'Storage', align: 'left', value: 'storage', key: 'storage', sortable: true, width: '10%'},
                    { text: 'Status', value: 'status', key: 'status', sortable: true, width: '20%' },
                    { text: 'Tags', value: 'tags', key: 'tags', sortable: true, width: '30%' },
                    { text: 'Actions', align: 'right', value: 'actions', key: 'actions', sortable: false, width: '15%' },
                ]
            },
            {
                name: "NFS File Storage",
                slug: "nfs-storage",
                detail: "Network File System (NFS) is a scalable, high-performance network file system protocol <br> that allows you to mount remote directories on your server.",
                add: {
                    detail: "Network File System (NFS) is a scalable, high-performance network file system protocol <br> that allows you to mount remote directories on your server.",
                    component: "NfsSetup",
                },
                edit: {
                    to: {
                        name: "nfs-overview"
                    }
                },
                headers: [
                    { text: 'Details', align: 'left', value: 'order_id', key: 'order_id', sortable: true, width: '25%'},
                    { text: 'Storage', align: 'left', value: 'storage', key: 'storage', sortable: true, width: '10%'},
                    { text: 'Status', value: 'status', key: 'status', sortable: true, width: '20%' },
                    { text: 'Tags', value: 'tags', key: 'tags', sortable: true, width: '30%' },
                    { text: 'Actions', align: 'right', value: 'actions', key: 'actions', sortable: false, width: '15%' },
                ]
            },
            {
                name: "RBD Block Storage",
                slug: "rbd-block-storage",
                add: {
                    detail: "RADOS Block Device (RBD Block Storage) provides fast, <br> scalable, and reliable block based distributed storage.",
                    component: "RdbBlockStorageSetup",
                },
                edit: {
                    to: {
                        name: "block-storage-overview"
                    }
                },
                headers: [
                    { text: 'Details', align: 'left', value: 'order_id', key: 'order_id', sortable: true, width: '25%'},
                    { text: 'Storage', align: 'left', value: 'storage', key: 'storage', sortable: true, width: '10%'},
                    { text: 'Status', value: 'status', key: 'status', sortable: true, width: '20%' },
                    { text: 'Tags', value: 'tags', key: 'tags', sortable: true, width: '30%' },
                    { text: 'Actions', align: 'right', value: 'actions', key: 'actions', sortable: false, width: '15%' },
                ]
            },
            {
                name: "Nimble",
                slug: "nimble",
                add: {
                    heading: "Get Started with Nimble Block Storage",
                    detail: "Fast, reliable block storage optimised for data storage and backups.",
                    component: "NimbleStorageSetup",
                },
                edit: {
                    to: {
                        name: "nimble-summary"
                    }
                }
            }
        ]
    },
    {
        name: "Backups",
        slug: "backups",
        products: [
            {
                name: "Veeam Cloud Connect",
                slug: "veeam-cloud-connect",
                detail: "Industry leading offsite data protection, providing confidence that your critical data will stay safe and secure",
                add: {
                    detail: "Industry leading offsite data protection, providing confidence that your critical data will stay safe and secure",
                    component: "VccBackupSetup",
                },
                edit: {
                    to: {
                        name: "vcc-backup-summary"
                    }
                }
            },
            {
                name: "Veeam Backup Instance",
                plural: "Veeam Backup Instances",
                slug: "veeam-backup-instance",
                add: {
                    detail: "Veeam Backup Instances provide high performance backup and restore capabilities, increased data protection, and reduced downtime in the event of a disaster.",
                    component: "VbiBackupSetup",
                },
                edit: {
                    to: {
                        name: "vbi-backup-summary"
                    }
                },
            },
            {
                name: "R1Soft",
                slug: "r1soft",
                disabled: true,
            }
        ]
    },
    {
        name: "Security",
        slug: "security",
        hidden: false,
        products: [
            {
                name: "Fortigate Firewall",
                plural: "Fortigate Firewalls",
                slug: "fortinet-firewall",
                alias: "fortigate-firewall",
                add: {
                    component: "FortinetFirewallSetup",
                    detail: "Fortigate Firewall provides a secure, scalable, and easy-to-manage solution to protect your servers and applications from malicious attacks.",
                },
                edit: {
                    to: {
                        name: "fortigate-firewall-summary"
                    }
                },
            }
        ]
    },
    {
        name: "Domains/SSL",
        slug: "domain",
        products: [
            {
                name: "Domain",
                plural: "Domains",
                slug: "domain",
                isNonCancellable: true,
                add: {
                    href: "/order/domain",
                    detail: "Register and manage domains.",
                },
                buttons: [
                    {
                        label: "Transfer Domain",
                        href: "/order/domain/transfer"
                    }
                ],
                headers: [
                    { text: "Domain", align: "left", value: "domain", sortable: true, width: "25%" },
                    { text: "Status", value: "status", "sortable": true, width: "20%"  },
                    { text: "Expiry Date",  value: "expiry_date", sortable: true, width: "25%" },
                    { text: "Auto Renew", value: "auto_renew", sortable: true, width: "15%"  },
                    { text: "Actions", align: "right", value: "actions", sortable: false, width: "15%" }
                ]
            },
            {
                name: "SSL",
                plural: "SSL",
                slug: "ssl-certificate",
                add: {
                    href: "/order/ssl-certificate",
                    detail: "Protect your application with our selection of SSL certificates.",
                },
                headers: [
                    { text: 'Details', align: 'left', value: 'order_id', key: 'order_id', sortable: true, width: '20%'},
                    { text: 'Domain/s', align: 'left', value: 'domains', key: 'domains', sortable: true, width: '30%'},
                    { text: 'Status', value: 'status', key: 'status', sortable: true, width: '20%' },
                    { text: 'Tags', value: 'tags', key: 'tags', sortable: true, width: '20%' },
                    { text: 'Actions', align: 'right', value: 'actions', key: 'actions', sortable: false, width: '10%' },
                ]
            }
        ]
    },
    {
        name: "Licenses",
        slug: "licenses",
        hideTabs: true,
        childRoutesMethod: "licenseCategoryRoutes",
        component: {
            key: "LicenseDashboard",
            path: "@v2/addons/licenses/LicenseDashboard",
            redirect: true,
        },
        products: []
    },
    {
        name: "Management",
        slug: "management",
        component: {
            key: "ManagementDashboard",
            path: "@v2/professional-services/ManagementDashboard"
        },
        hideTabs: true,
        products: [
            {
                name: "Professional Services Agreement",
                slug: "professional-services-agreement",
                component: {
                    key: "PsaDashboard",
                    path: "@view/PsaDashboardView"
                }
            },
            {
                name: "Monitoring and Maintenance Agreement",
                plural: "Monitoring and Maintenance Agreements",
                slug: "monitoring-maintenance-agreement",
                component: {
                    key: "MmaOrder",
                    path: "@v2/professional-services/MmaOrder"
                }
            }
        ]
    },
    {
        name: "VMware Licensing & Support",
        slug: "vmware",
        hideEmpty: true,
        products: [
            {
                name: "VMware Support",
                slug: "vmware-licensing-support",
                isNonCancellable: true,
                edit: { disabled: true },
                customActions: [
                    {
                        module: "vmware",
                        action: "showModal",
                        label: "Usage",
                        icon: "fal fa-tachometer",
                    }
                ]
            },
            {
                name: "VMware Licensing",
                slug: "vmware-licensing",
                edit: { disabled: true },
                isNonCancellable: true,
                isSupportCaseDisabled: true,
                headers: [
                    { text: 'Details', align: 'left', value: 'order_id', key: 'order_id', sortable: true},
                    { text: 'Status', value: 'status', key: 'status', sortable: true },
                    { text: 'Cores', value: 'licensed_cores', key: 'licensed_cores', sortable: true, isDetails: true },
                    { text: 'Monthly Price/Core', value: 'monthly_cost_per_core', key: 'monthly_cost_per_core', sortable: true, isDetails: true },
                    { text: 'Billed', value: 'billing_cycle', key: 'tags', sortable: true },
                    { text: 'Contract End Date', value: 'saucontractenddate', key: 'saucontractenddate', sortable: true, isDetails: true },
                ]
            },
        ]
    },
    {
        name: "Other",
        slug: "other",
        products: [
            {
                name: "Other",
                plural: "Other Services",
                slug: "other",
                headers: [
                    { text: 'Details', align: 'left', value: 'order_id', key: 'order_id', sortable: true, width: '25%'},
                    { text: 'Status', value: 'status', key: 'status', sortable: true, width: '20%' },
                    { text: 'Tags', value: 'tags', key: 'tags', sortable: true, width: '40%' },
                    { text: 'Actions', align: 'right', value: 'actions', key: 'actions', sortable: false, width: '15%' },
                ],
                add: {
                    detail: "No matching services.",
                }
            },
            {
                name: "BGP Transit",
                slug: "bgp-transit",
                isNonCancellable: false,
                edit: { 
                    to: {
                        name: "bgp-transit-summary"
                    }
                 },
            },
        ]
    }
]
